import { setMain } from "../components/shell";
import { site, horse, races, faq, legal, formatGBP, formatDate, tiersCardsHtml } from "../lib/content";

export function pageHome(): void {
  const h = site.home;
  setMain(`
    <section class="hero-home hero-home--horse">
      <div class="container hero-home__grid">
        <div class="hero-home__copy">
          <div class="kicker"><span class="pill pill--gold" style="background:rgba(255,255,255,0.75);color:var(--cg-ink);border:1px solid rgba(142,153,171,0.45)">Shares available</span> ${site.club.feeLabel}</div>
          <h1>${h.heroTitle}</h1>
          <div class="divider-gold"></div>
          <p class="lede">${h.heroLead}</p>
          <div class="row" style="margin-top:1.5rem">
            <a class="btn btn--gold" href="${h.heroCtaPrimary.href}">${h.heroCtaPrimary.label}</a>
            <a class="btn btn--ghost" href="${h.heroCtaSecondary.href}">${h.heroCtaSecondary.label}</a>
          </div>
        </div>
        <a class="hero-home__photo" href="/horse" aria-label="View horse profile — unnamed by Ardad">
          <img src="/horses/ardad-unnamed-ridden.jpg" alt="Unnamed by Ardad on the gallops" width="720" height="480" />
        </a>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <div class="row" style="justify-content:space-between;margin-bottom:1.5rem">
          <h2>Why Piece of the Action</h2>
          <span class="pill pill--navy">${site.disclaimers.short}</span>
        </div>
        <div class="grid-3">
          ${h.highlights
            .map(
              (c) => `
            <article class="card card--lift">
              <div class="card__eyebrow">Syndicate</div>
              <h3>${c.title}</h3>
              <p style="color:var(--cg-muted);margin:0">${c.body}</p>
            </article>`
            )
            .join("")}
        </div>
      </div>
    </section>

    <section class="section section--cream">
      <div class="container">
        <div class="row" style="justify-content:space-between;align-items:end;margin-bottom:1.25rem;gap:1rem">
          <div>
            <div class="kicker" style="color:var(--cg-green-700)">Share tiers</div>
            <h2 style="margin:0">10% · 5% · 2.5%</h2>
          </div>
          <a class="btn btn--primary" href="/membership">See shares &amp; pricing</a>
        </div>
        <div class="grid-3">${tiersCardsHtml()}</div>
      </div>
    </section>

    <section class="section">
      <div class="container two-col">
        <div>
          <div class="kicker" style="color:var(--cg-green-700)">The horse</div>
          <h2>${horse.displayName}</h2>
          <p>${horse.summary}</p>
          <p>${horse.publicTeaser}</p>
          <a class="btn btn--primary" href="/horse">View horse profile</a>
        </div>
        <a class="horse-panel horse-panel--photo" href="/horse" style="display:block;text-decoration:none;padding:0;overflow:hidden">
          <img src="/horses/ardad-unnamed-standing.jpg" alt="Unnamed by Ardad — standing" style="width:100%;height:100%;object-fit:cover;object-position:top center;display:block;min-height:280px" />
          <span class="pill pill--gold horse-panel__badge">${horse.status}</span>
        </a>
      </div>
    </section>

    <section class="section section--cream">
      <div class="container">
        <div class="card" style="background:linear-gradient(120deg,#ffffff 0%,#f4f5f7 50%,#eef1f5 100%);color:var(--cg-ink);border:1px solid rgba(142,153,171,0.45);box-shadow:inset 0 1px 0 rgba(255,255,255,0.85)">
          <div class="two-col" style="align-items:center">
            <div>
              <h2 style="color:var(--cg-ink)">Apply for a share</h2>
              <p style="color:var(--cg-muted)">Choose 10%, 5%, or 2.5%. Updates · yard visits as owners · badge ballots · prize money annually by %. Apply only — no live card capture in v1.</p>
              <div class="row">
                <a class="btn btn--gold" href="/join">Apply now</a>
                <a class="btn btn--ghost" href="/membership">Compare tiers</a>
              </div>
            </div>
            <div class="callout" style="background:rgba(255,255,255,0.65);border-left-color:var(--cg-gold-400);color:var(--cg-ink)">
              <strong>Syndicate share.</strong> You hold a % entitlement as a co-owner by share. Prize money is distributed annually by share %. Returns are not guaranteed.
            </div>
          </div>
        </div>
      </div>
    </section>
  `);
  document.title = `${site.club.name} — Home`;
}

export function pageAbout(): void {
  const a = site.about;
  const explainer = a.syndicateExplainer;
  setMain(`
    <section class="page-hero">
      <div class="container">
        <div class="kicker" style="color:var(--cg-green-700)">How it works</div>
        <h1>${a.title}</h1>
        <p class="lede">${a.intro}</p>
      </div>
    </section>
    <section class="section section--tight">
      <div class="container grid-2">
        ${a.steps
          .map(
            (s) => `
          <article class="card">
            <div class="step-n">${s.n}</div>
            <h3>${s.title}</h3>
            <p style="margin:0;color:var(--cg-muted)">${s.body}</p>
          </article>`
          )
          .join("")}
      </div>
    </section>
    <section class="section section--cream">
      <div class="container">
        <h2>${explainer.title}</h2>
        <ul class="list-check" style="max-width:40rem;margin-top:1rem">
          ${explainer.points.map((p) => `<li>${p}</li>`).join("")}
        </ul>
        <div class="callout" style="margin-top:1.5rem;max-width:40rem">
          <strong>Prize money annually by share %.</strong> When the horse earns, your entitlement is distributed annually in proportion to your %. Amounts are never guaranteed.
        </div>
      </div>
    </section>
  `);
  document.title = `How it works — ${site.club.name}`;
}

export function pageHorse(): void {
  const p = horse.placeholders;
  const stats = horse as unknown as {
    careerStats?: {
      runs: number;
      wins: number;
      seconds: number;
      officialRating: number | null;
      prizeMoneyApprox?: string;
    };
    futurePotential?: string;
    disclaimer?: string;
    label?: string;
    formHighlights?: string[];
    profile?: { publicOwner?: string; breeder?: string; formString?: string };
    heroImages?: { src: string; alt: string }[];
  };
  const cs = stats.careerStats;
  const profileOwner = stats.profile?.publicOwner ?? "Piece of the Action Racing";
  const formStr = stats.profile?.formString ?? "";
  const breeder = stats.profile?.breeder ?? "TBA";
  const heroImages = stats.heroImages ?? [
    { src: "/horses/ardad-unnamed-standing.jpg", alt: "Unnamed by Ardad — standing" },
    { src: "/horses/ardad-unnamed-ridden.jpg", alt: "Unnamed by Ardad — on the gallops" },
  ];

  setMain(`
    <section class="page-hero">
      <div class="container">
        <div class="kicker" style="color:var(--cg-green-700)">The horse</div>
        <h1>${horse.displayName}</h1>
        <p class="lede">${horse.summary}</p>
        <div class="row" style="margin-top:0.75rem">
          <span class="pill pill--gold">${stats.label ?? "Syndicate horse"}</span>
          <span class="pill pill--navy">Co-owners by share %</span>
          <span class="pill pill--green">Prize annually by %</span>
        </div>
      </div>
    </section>
    <section class="section section--tight">
      <div class="container">
        <div class="horse-gallery">
          ${heroImages.map((img) => `<figure class="horse-gallery__item"><img src="${img.src}" alt="${img.alt}" loading="lazy" /><figcaption>${img.alt}</figcaption></figure>`).join("")}
        </div>
      </div>
    </section>
    <section class="section section--tight">
      <div class="container two-col">
        <div class="horse-panel" style="min-height:280px">
          <span class="pill pill--gold horse-panel__badge">${horse.status}</span>
          <h2 style="color:var(--cg-ink);font-size:2.4rem;margin:0">${horse.name}</h2>
          <p style="color:var(--cg-muted)">${horse.publicTeaser}</p>
          ${formStr ? `<p style="color:var(--cg-cream-100);margin:0.75rem 0 0;font-family:var(--font-display)">Form ${formStr}</p>` : ""}
          <div class="row" style="margin-top:1rem">
            <a class="btn btn--gold" href="/join">Apply for a share</a>
            <a class="btn btn--ghost" href="/membership">See buy-in tiers</a>
          </div>
        </div>
        <div class="stack">
          <div class="card">
            <h3>Profile</h3>
            <div class="table-wrap" style="border:0;box-shadow:none">
              <table class="data">
                <tbody>
                  <tr><th>Trainer</th><td>${p.trainer}</td></tr>
                  <tr><th>Breeder</th><td>${breeder}</td></tr>
                  <tr><th>Public registered owner</th><td>${profileOwner}</td></tr>
                  <tr><th>Age / DOB</th><td>${p.age}</td></tr>
                  <tr><th>Sex / colour</th><td>${p.sex}</td></tr>
                  <tr><th>Breeding</th><td>${p.breeding}</td></tr>
                  <tr><th>Nominations</th><td>${(horse as { profile?: { nominations?: string } }).profile?.nominations ?? "—"}</td></tr>
                  <tr><th>Colours</th><td>${p.colours}</td></tr>
                  <tr><th>Target</th><td>${p.target}</td></tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="callout">
            ${stats.disclaimer ?? "Syndicate share · prize money distributed annually by share %. Public registered owner: Piece of the Action Racing."}
          </div>
          <div class="card" style="margin-top:1rem">
            <h3>Pedigree notes</h3>
            <p style="margin:0 0 0.5rem;color:var(--cg-muted)">Ardad (Kodiac–Good Clodora) × Aegean Girl (Henrythenavigator–Catch The Moon)</p>
            <ul class="list-check" style="margin-top:0.75rem">
              ${((horse as { pedigree?: { notes?: string[] } }).pedigree?.notes ?? []).map((n) => `<li>${n}</li>`).join("")}
            </ul>
          </div>
        </div>
      </div>
    </section>
    ${
      cs
        ? `
    <section class="section section--cream">
      <div class="container">
        <h2>Career stats</h2>
        <div class="stat-grid" style="margin-top:1rem">
          <div class="stat"><div class="stat__label">Runs</div><div class="stat__value">${cs.runs}</div></div>
          <div class="stat"><div class="stat__label">Wins</div><div class="stat__value">${cs.wins}</div></div>
          <div class="stat"><div class="stat__label">2nds</div><div class="stat__value">${cs.seconds}</div></div>
          <div class="stat"><div class="stat__label">OR</div><div class="stat__value">${cs.officialRating}</div></div>
        </div>
        ${cs.prizeMoneyApprox ? `<p style="margin-top:1rem;color:var(--cg-muted);font-size:0.95rem">Approx. career prize money (public figures): ${cs.prizeMoneyApprox}. Syndicate members receive their share annually by % — amounts not guaranteed.</p>` : ""}
        ${
          stats.formHighlights?.length
            ? `<ul class="list-check" style="margin-top:1.25rem;max-width:44rem">${stats.formHighlights.map((x) => `<li>${x}</li>`).join("")}</ul>`
            : ""
        }
      </div>
    </section>`
        : ""
    }
    <section class="section">
      <div class="container">
        <div class="row" style="justify-content:space-between;align-items:end;margin-bottom:1rem;gap:1rem">
          <div>
            <h2>${races.title}</h2>
            <p style="margin:0.35rem 0 0;color:var(--cg-muted);max-width:40rem">${races.intro}</p>
          </div>
        </div>
        <div class="table-wrap">
          <table class="data">
            <thead>
              <tr><th>Date</th><th>Course</th><th>Race</th><th>Cl</th><th>Pos</th><th>SP</th><th>Notes</th></tr>
            </thead>
            <tbody>
              ${races.entries
                .map((r) => {
                  const row = r as {
                    date: string;
                    course: string;
                    race: string;
                    class?: string;
                    pos?: string;
                    sp?: string;
                    status: string;
                    notes: string;
                  };
                  const posPill =
                    row.status === "Won"
                      ? "pill--green"
                      : row.status === "2nd"
                        ? "pill--gold"
                        : "pill--navy";
                  return `
                <tr>
                  <td>${formatDate(row.date)}</td>
                  <td>${row.course}</td>
                  <td>${row.race}</td>
                  <td>${row.class ? `Cl${row.class}` : "—"}</td>
                  <td><span class="pill ${posPill}">${row.pos ?? row.status}</span></td>
                  <td>${row.sp ?? "—"}</td>
                  <td>${row.notes}</td>
                </tr>`;
                })
                .join("")}
            </tbody>
          </table>
        </div>
        ${
          (races as { lookingAhead?: string }).lookingAhead
            ? `<div class="callout" style="margin-top:1.25rem"><strong>Looking ahead:</strong> ${(races as { lookingAhead?: string }).lookingAhead}</div>`
            : ""
        }
      </div>
    </section>
    ${
      stats.futurePotential
        ? `
    <section class="section section--cream">
      <div class="container two-col">
        <div>
          <h2>Future potential</h2>
          <p>${stats.futurePotential}</p>
          <p style="color:var(--cg-muted);font-size:0.95rem">Progressive 3yo · trip ~7f · Yorkshire home-bred. Form is not a tip or certainty.</p>
        </div>
        <div class="card">
          <h3>Co-own by share</h3>
          <p style="color:var(--cg-muted)">Piece of the Action is a syndicate share product. You hold a % entitlement and receive prize money annually by share %. Public registered owner remains <strong>${profileOwner}</strong>.</p>
          <div style="margin-top:0.75rem"><a class="btn btn--sm btn--primary" href="/join">Apply for a share</a></div>
        </div>
      </div>
    </section>`
        : ""
    }
  `);
  document.title = `${horse.name} — ${site.club.name}`;
}

export function pageMembership(): void {
  const m = site.membership;
  setMain(`
    <section class="page-hero">
      <div class="container">
        <div class="kicker" style="color:var(--cg-green-700)">Shares</div>
        <h1>${m.title}</h1>
        <p class="lede">${m.intro}</p>
        <div class="row" style="margin-top:1rem">
          <a class="btn btn--primary" href="/join">Apply for a share</a>
          <span class="pill pill--green">Prize annually by %</span>
          <span class="pill pill--navy">Co-owners by share</span>
        </div>
      </div>
    </section>
    <section class="section section--tight">
      <div class="container">
        <h2 style="margin-bottom:1rem">Pricing</h2>
        <div class="grid-3">${tiersCardsHtml()}</div>
      </div>
    </section>
    <section class="section section--cream">
      <div class="container grid-3">
        ${m.benefits
          .map(
            (b) => `
          <article class="card card--lift">
            <div class="card__eyebrow">Included</div>
            <h3>${b.title}</h3>
            <p style="margin:0;color:var(--cg-muted)">${b.body}</p>
          </article>`
          )
          .join("")}
      </div>
    </section>
    <section class="section section--cream">
      <div class="container">
        <div class="kicker" style="color:var(--cg-green-700)">Monthly keep</div>
        <h2 style="margin:0 0 0.75rem">What’s included every month</h2>
        <p style="max-width:40rem;color:var(--cg-muted)">${(m as { includedInMonthlyNote?: string }).includedInMonthlyNote ?? "Monthly payments include all expenses for your share: training fees, vets, farrier, jockeys’ fees, race entries, and raceday expenses."}</p>
        <ul class="list-check" style="margin-top:1rem;max-width:36rem">
          ${((m as { includedInMonthly?: string[] }).includedInMonthly ?? []).map((x) => `<li>${x}</li>`).join("")}
        </ul>
      </div>
    </section>
    <section class="section">
      <div class="container two-col">
        <div>
          <h2>Explicitly not included</h2>
          <ul class="list-check list-cross">
            ${m.explicitlyNot.map((x) => `<li>${x}</li>`).join("")}
          </ul>
        </div>
        <div class="card">
          <h3>At a glance</h3>
          <div class="stat-grid">
            <div class="stat"><div class="stat__label">Tiers</div><div class="stat__value" style="font-size:1.4rem">3</div></div>
            <div class="stat"><div class="stat__label">Horses</div><div class="stat__value">1</div></div>
            <div class="stat"><div class="stat__label">From</div><div class="stat__value" style="font-size:1.4rem">${formatGBP(75)}</div></div>
          </div>
          <p style="margin-top:1rem;font-size:0.9rem;color:var(--cg-muted)">Payment is stubbed in v1 — the join form does not charge your card. Apply / express interest only.</p>
        </div>
      </div>
    </section>
  `);
  document.title = `Shares — ${site.club.name}`;
}

export function pageFaq(): void {
  setMain(`
    <section class="page-hero">
      <div class="container">
        <div class="kicker" style="color:var(--cg-green-700)">FAQ</div>
        <h1>${faq.title}</h1>
        <p class="lede">Straight answers on syndicate shares, costs, annual prize by %, risks, and who appears on the race card.</p>
      </div>
    </section>
    <section class="section section--tight">
      <div class="container faq" style="max-width:48rem">
        ${faq.items
          .map(
            (i) => `
          <details>
            <summary>${i.q}</summary>
            <p style="margin:0;color:var(--cg-muted)">${i.a}</p>
          </details>`
          )
          .join("")}
      </div>
    </section>
  `);
  document.title = `FAQ — ${site.club.name}`;
}

export function pageContact(): void {
  setMain(`
    <section class="page-hero">
      <div class="container">
        <div class="kicker" style="color:var(--cg-green-700)">Contact</div>
        <h1>${site.contact.title}</h1>
        <p class="lede">${site.contact.intro}</p>
      </div>
    </section>
    <section class="section section--tight">
      <div class="container two-col">
        <form class="card form" id="contact-form">
          <div class="field">
            <label for="c-name">Name</label>
            <input id="c-name" name="name" required autocomplete="name" />
          </div>
          <div class="field">
            <label for="c-email">Email</label>
            <input id="c-email" name="email" type="email" required autocomplete="email" />
          </div>
          <div class="field">
            <label for="c-msg">Message</label>
            <textarea id="c-msg" name="message" required></textarea>
            <div class="hint">${site.contact.note}</div>
          </div>
          <button class="btn btn--primary" type="submit">Send message (stub)</button>
          <div id="contact-msg" hidden></div>
        </form>
        <div class="stack">
          <div class="card">
            <h3>Syndicate details</h3>
            <p><strong>Email</strong><br>${site.club.email}</p>
            <p><strong>Phone</strong><br>${site.club.phone}</p>
            <p style="white-space:pre-line"><strong>Address</strong><br>${site.club.address}</p>
          </div>
          <div class="callout">Demo only — messages are saved to <code>localStorage</code>, not emailed.</div>
        </div>
      </div>
    </section>
  `);
  document.title = `Contact — ${site.club.name}`;
  document.getElementById("contact-form")?.addEventListener("submit", (e) => {
    e.preventDefault();
    const fd = new FormData(e.target as HTMLFormElement);
    const payload = Object.fromEntries(fd.entries());
    const key = "pota.contact";
    const prev = JSON.parse(localStorage.getItem(key) || "[]");
    prev.push({ ...payload, at: new Date().toISOString() });
    localStorage.setItem(key, JSON.stringify(prev));
    const box = document.getElementById("contact-msg")!;
    box.hidden = false;
    box.className = "form-msg form-msg--ok";
    box.textContent = "Message saved locally (demo). No email was sent.";
    (e.target as HTMLFormElement).reset();
  });
}

export function pageJoin(): void {
  const tierOptions = site.tiers
    .map((t) => { const tt = t as unknown as { id: string; label: string; buyIn?: number | null; pcm?: number | null }; const buy = Number(tt.buyIn ?? 0); const pcm = Number(tt.pcm ?? 0); const price = buy && pcm ? `${formatGBP(buy)} buy-in + ${formatGBP(pcm)}/mo` : buy ? `${formatGBP(buy)} buy-in` : `${formatGBP(pcm)}/mo`; return `<option value="${tt.id}">${tt.label} — ${price}</option>`; })
    .join("");
  setMain(`
    <section class="page-hero">
      <div class="container">
        <div class="kicker" style="color:var(--cg-green-700)">Join</div>
        <h1>${site.join.title}</h1>
        <p class="lede">${site.join.intro}</p>
      </div>
    </section>
    <section class="section section--tight">
      <div class="container two-col">
        <form class="card form" id="join-form">
          <div class="callout">${site.join.feeNote}</div>
          <div class="field">
            <label for="j-tier">Share tier</label>
            <select id="j-tier" name="tier" required>
              <option value="" disabled selected>Select a tier</option>
              ${tierOptions}
            </select>
          </div>
          <div class="field">
            <label for="j-name">Full name</label>
            <input id="j-name" name="name" required autocomplete="name" />
          </div>
          <div class="field">
            <label for="j-email">Email</label>
            <input id="j-email" name="email" type="email" required autocomplete="email" />
          </div>
          <div class="field">
            <label for="j-phone">Phone (optional)</label>
            <input id="j-phone" name="phone" type="tel" autocomplete="tel" />
          </div>
          <div class="field">
            <label>
              <input type="checkbox" name="confirm" required style="width:auto;margin-right:0.4rem" />
              I understand this is a syndicate share application: prize money is distributed annually by share %, returns are not guaranteed, and no payment is taken on this form.
            </label>
          </div>
          <button class="btn btn--primary btn--block" type="submit">Submit application (no payment)</button>
          <div id="join-msg" hidden></div>
        </form>
        <div class="stack">
          <div class="card">
            <h3>What happens next</h3>
            <ol>
              <li>We review your share application (live process TBA).</li>
              <li>Payment will be collected via a future checkout — <strong>not wired in v1</strong>.</li>
              <li>You receive members-area access (My shares, prize ledger) and welcome pack details.</li>
            </ol>
          </div>
          <div class="callout callout--ok">14-day cooling-off is described in the syndicate agreement stub. This form does not create a binding paid contract.</div>
          <p><a href="/terms">Read syndicate agreement stub</a> · <a href="/privacy">Privacy stub</a></p>
        </div>
      </div>
    </section>
  `);
  document.title = `Join — ${site.club.name}`;
  document.getElementById("join-form")?.addEventListener("submit", (e) => {
    e.preventDefault();
    const fd = new FormData(e.target as HTMLFormElement);
    const payload = Object.fromEntries(fd.entries());
    const tier = site.tiers.find((t) => t.id === String(payload.tier));
    const key = "pota.join";
    const prev = JSON.parse(localStorage.getItem(key) || "[]");
    prev.push({
      ...payload,
      at: new Date().toISOString(),
      sharePercent: tier?.sharePercent ?? null,
      buyIn: (tier as unknown as { buyIn?: number | null; pcm?: number | null } | undefined)?.buyIn ?? (tier as unknown as { pcm?: number | null } | undefined)?.pcm ?? null,
    });
    localStorage.setItem(key, JSON.stringify(prev));
    const box = document.getElementById("join-msg")!;
    box.hidden = false;
    box.className = "form-msg form-msg--ok";
    box.textContent = site.join.successStub;
    (e.target as HTMLFormElement).reset();
  });
}

function legalPage(kind: "privacy" | "terms"): void {
  const doc = legal[kind];
  setMain(`
    <section class="page-hero">
      <div class="container">
        <div class="kicker" style="color:var(--cg-green-700)">Legal stub</div>
        <h1>${doc.title}</h1>
        <p class="lede">Last updated ${doc.updated}. Illustrative only — not legal advice. Draft — not final.</p>
      </div>
    </section>
    <section class="section section--tight">
      <div class="container" style="max-width:44rem">
        <div class="callout callout--alert" style="margin-bottom:1.5rem">
          These stubs clarify syndicate share positioning (share %, annual prize by %, risk, apply-not-pay, cooling-off). Have a solicitor review before go-live.
        </div>
        ${doc.sections
          .map(
            (s) => `
          <article style="margin-bottom:1.5rem">
            <h3>${s.heading}</h3>
            <p style="color:var(--cg-muted)">${s.body}</p>
          </article>`
          )
          .join("")}
      </div>
    </section>
  `);
  document.title = `${doc.title} — ${site.club.name}`;
}

export function pagePrivacy(): void {
  legalPage("privacy");
}

export function pageTerms(): void {
  legalPage("terms");
}

export function pageComplaints(): void {
  setMain(`
    <section class="page-hero">
      <div class="container">
        <div class="kicker" style="color:var(--pota-secondary)">Legal stub</div>
        <h1>Complaints</h1>
        <p class="lede">Draft — not final. Illustrative only — not a live complaints channel.</p>
      </div>
    </section>
    <section class="section section--tight">
      <div class="container" style="max-width:44rem">
        <div class="callout callout--alert" style="margin-bottom:1.5rem">
          This complaints procedure is a draft stub. Final wording will come from Admin legal drafts. Have a solicitor review before go-live.
        </div>
        <article style="margin-bottom:1.5rem">
          <h3>How to raise a concern</h3>
          <p style="color:var(--pota-muted)">Email the contact address on the Contact page with your name, share tier (if any), and a clear description of the issue. In this demo, no email is sent.</p>
        </article>
        <article style="margin-bottom:1.5rem">
          <h3>What happens next</h3>
          <p style="color:var(--pota-muted)">A live process will acknowledge receipt and set out timescales. This stub does not create a regulated complaints pathway.</p>
        </article>
        <p><a href="/contact">Contact</a> · <a href="/terms">Syndicate Terms (draft)</a> · <a href="/privacy">Privacy (draft)</a></p>
      </div>
    </section>
  `);
  document.title = `Complaints (draft) — ${site.club.name}`;
}

export function pageNotFound(): void {
  setMain(`
    <section class="section">
      <div class="container" style="text-align:center;padding:4rem 0">
        <h1>Page not found</h1>
        <p>That route isn’t part of the Piece of the Action v1 site.</p>
        <a class="btn btn--primary" href="/">Back home</a>
      </div>
    </section>
  `);
  document.title = `Not found — ${site.club.name}`;
}
